<span class="fa fa-info-circle small-icon fake-link" 
      [ngbTooltip]="legendToolTipContent" #tooltip="ngbTooltip" openDelay="{{tooltipOpenDelay}}"
      tooltipClass="rms-tooltip rms-tooltip-p-0" container="body" placement="right-top"></span>

<ng-template #legendToolTipContent>
  <div class="legend" *ngFor="let legend of legends">
    <div class="legend-color" [ngStyle]="{'backgroundColor': legend.color}">&nbsp;</div>
    <div [ngClass]="!!legend.label.split(' ')[1] && 'font-medium'" class="legend-label">
      {{legend.label.split(' ')[0]}}
    </div>
    <div *ngIf="legend.label.split(' ')[1]" class="legend-sublabel">{{legend.label.split(' ')[1]}}</div>
  </div>
  
</ng-template>
